import { ReduxAction } from 'types/redux';
import { FORGOT_PASSWORD } from "../../constants/forgot-password.constants";

const initialState = {
  loading: false,
  data: false,
  error: '',
  resendLoading: false,
  resendError: '',
};

export function forgotPassword(state = initialState, action: ReduxAction) {
  switch (action.type) {
    case FORGOT_PASSWORD.FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        data: false,
        error: '',
      };
    case FORGOT_PASSWORD.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        data: true,
        loading: false,
        error: '',
      };
    case FORGOT_PASSWORD.FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        data: false,
        error: action.error,
      };
    case FORGOT_PASSWORD.FORGOT_PASSWORD_CLEAR:
      return {
        ...state,
        loading: false,
        data: false,
        error: '',
      };
    case FORGOT_PASSWORD.RESEND_CODE_REQUEST:
      return {
        ...state,
        resendLoading: true,
        resendError: '',
      };
    case FORGOT_PASSWORD.RESEND_CODE_SUCCESS:
      return {
        ...state,
        resendLoading: false,
        resendError: '',
      };
    case FORGOT_PASSWORD.RESEND_CODE_FAILURE:
      return {
        ...state,
        resendLoading: false,
        resendError: action.error,
      };
    default:
      return state;
  }
}
